'use strict'
var Promise = require('es6-promise');
import request  from 'axios'

export const all = (params) => {

	var token = $("meta[name='csrf-token']").attr("content")
	
	params.params = params.params || {};
	params.data = params.data || {};

	const urlRoot				= "/migration"
	const method				= params.method
	const url						= `${urlRoot}${params.path}`
	const responseType	= 'json'
	const headers = {
		"X-CSRF-Token" : token
	};

	const requestParams = { method, url, responseType, headers }

	// `data` is the data to be sent as the request body
	// Only applicable for request methods 'PUT', 'POST', and 'PATCH'
	// When no `transformRequest` is set, must be a string, an ArrayBuffer or a hash
	if (params.data) requestParams.data = params.data

	// `param` are the URL parameters to be sent with the request
	if (params.params) requestParams.params = params.params

	return request(requestParams)
}

export const migGET = (path, params) => {
	var getParams = {
		urlRoot: '/migration',
		path: path,
		method: 'GET',
		params: params
	}
	return all(getParams)
}

export const migPOST = (path, params) => {
	var postParams = {
		urlRoot: '/migration',
		path: path,
		method: 'POST',
		data: params
	}
	return all(postParams)
}
